// @ts-nocheck
/* eslint-enable */
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useExperiment = (experimentName) => {
  const dispatch = useDispatch();
  const experiment = useSelector((state) => state.analytics.runningExperiments[experimentName]) || {};
  const queryParamOverridePresent = useSelector(
    (state) => state.analytics.runningExperiments[experimentName]?.queryParamOverridePresent,
  );

  useEffect(() => {
    // noop if no experiment name
    if (!experimentName || queryParamOverridePresent) {
      return;
    }
  }, [dispatch, queryParamOverridePresent, experimentName]);

  // explicitly return true if experiment name not given or experiment not found -- should NOT show any experimental behavior
  if (!experimentName || isEmpty(experiment)) {
    return true;
  }

  const { isControl } = experiment;
  return isControl;
};
